(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 170);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 170:
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./app/profile/announcement-settings.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _locale = __webpack_require__(/*! ../../jsw/locale */ 63);

var _closableAlert = __webpack_require__(/*! ./closable-alert */ 72);

var _closableAlert2 = _interopRequireDefault(_closableAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE_SEND_ANNOUNCE = 'send_announce'; // Copyright 1999-2019. Plesk International GmbH. All rights reserved.

var TYPE_SEND_PERSONALIZED_ANNOUNCE = 'send_personalized_announce';
var TYPE_NONE = 'none';

exports.default = function (_ref) {
    var id = _ref.id,
        getConsentUrl = _ref.getConsentUrl,
        closeConsentInfoUrl = _ref.closeConsentInfoUrl,
        email = _ref.email,
        infoClosed = _ref.infoClosed,
        dialogShown = _ref.dialogShown,
        locale = _ref.locale;

    locale = new _locale.Locale(locale);
    var loaderBlock = document.getElementById(id + '-loader');
    var input = document.getElementById('' + id);
    var infoBlock = document.getElementById(id + '-info');
    var checkbox = document.getElementById(id + '-checkbox');
    var checkboxBlock = document.getElementById(id + '-checkbox-block');
    var radioBlock = document.getElementById(id + '-radio-block');
    var warningBlock = document.getElementById(id + '-warning');
    var retryButton = document.getElementById(id + '-retry');

    var hasPersonalizedConsent = function hasPersonalizedConsent(consents) {
        return consents.some(function (consent) {
            return consent.type === TYPE_SEND_PERSONALIZED_ANNOUNCE;
        });
    };

    var showInfoMsg = function showInfoMsg(consents) {
        if (hasPersonalizedConsent(consents)) {
            return;
        }

        if (consents.length > 0) {
            !infoClosed && (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
                _closableAlert2.default,
                { onClose: function onClose() {
                        return new Ajax.Request(closeConsentInfoUrl, { method: 'post' });
                    } },
                locale.lmsg('consentGivenInfo')
            ), infoBlock);
        } else if (dialogShown) {
            (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
                _uiLibrary.Alert,
                { intent: 'info' },
                locale.lmsg('consentNotGivenInfo')
            ), infoBlock);
        }
    };

    var showConsent = function showConsent(consents) {
        if (hasPersonalizedConsent(consents)) {
            checkbox.checked = true;
            checkboxBlock.style.display = '';
            input.value = TYPE_SEND_PERSONALIZED_ANNOUNCE;
            checkbox.addEventListener('change', function (e) {
                input.value = e.target.checked ? TYPE_SEND_PERSONALIZED_ANNOUNCE : TYPE_NONE;
            });
        } else if (consents.length > 0) {
            radioBlock.style.display = '';
            input.value = TYPE_SEND_ANNOUNCE;
            radioBlock.addEventListener('change', function (e) {
                input.value = e.target.value;
            });
        } else {
            checkbox.checked = false;
            checkboxBlock.style.display = '';
            input.value = TYPE_NONE;
            checkbox.addEventListener('change', function (e) {
                input.value = e.target.checked ? TYPE_SEND_PERSONALIZED_ANNOUNCE : TYPE_NONE;
            });
        }
    };

    var loadConsentStatus = function loadConsentStatus() {
        checkboxBlock.style.display = 'none';
        radioBlock.style.display = 'none';
        warningBlock.style.display = 'none';
        loaderBlock.style.display = '';

        new Ajax.Request(getConsentUrl, {
            method: 'get',
            parameters: { email: email },
            onSuccess: function onSuccess(transport) {
                var response = JSON.parse(transport.responseText);
                loaderBlock.style.display = 'none';

                if (response.status === 'error' || !response.consents) {
                    warningBlock.style.display = '';
                } else {
                    var consents = response.consents.filter(function (consent) {
                        return consent.enabled;
                    });
                    showInfoMsg(consents);
                    showConsent(consents);
                }
            },
            onFailure: function onFailure() {
                loaderBlock.style.display = 'none';
                warningBlock.style.display = '';
            }
        });
    };

    retryButton.addEventListener('click', function (e) {
        e.preventDefault();
        loadConsentStatus();
    });

    loadConsentStatus();
};

/***/ }),

/***/ 63:
/* exports provided: Locale */
/* all exports used */
/*!***********************!*\
  !*** ./jsw/locale.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Locale", function() { return Locale; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * @class Locale
 */
var Locale = function () {
    function Locale(messages) {
        _classCallCheck(this, Locale);

        this.messages = messages || {};
    }

    /**
     * Get locale message by key.
     * @param {String} key
     * @param {Object} [params]
     * @returns {String}
     */


    _createClass(Locale, [{
        key: 'lmsg',
        value: function lmsg(key, params) {
            var value = this.messages[key];
            if ('undefined' === typeof value) {
                return '[' + key + ']';
            }

            if ('undefined' === typeof params) {
                return value;
            }

            return Object.keys(params).reduce(function (value, paramKey) {
                return value.replace('%%' + paramKey + '%%', params[paramKey]);
            }, value);
        }
    }]);

    return Locale;
}();

Locale.sections = {};

/**
 * Register new locale section
 * @param {String} name
 * @param {Object} [messages]
 * @static
 */
Locale.addSection = function (name, messages) {
    this.sections[name] = new Locale(messages);
};

/**
 * Returns registered locale section or created empty section
 * @param {String} name
 * @returns {Locale}
 * @static
 */
Locale.getSection = function (name) {
    if (!this.sections[name]) {
        this.sections[name] = new Locale();
    }
    return this.sections[name];
};

/***/ }),

/***/ 72:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./app/profile/closable-alert.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var ClosableAlert = function (_Component) {
    _inherits(ClosableAlert, _Component);

    function ClosableAlert() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClosableAlert);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClosableAlert.__proto__ || Object.getPrototypeOf(ClosableAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpen: true
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClosableAlert, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                _onClose = _props.onClose;


            return this.state.isOpen ? (0, _uiLibrary.createElement)(
                _uiLibrary.Alert,
                {
                    intent: "info",
                    onClose: function onClose() {
                        _onClose();
                        _this2.setState({
                            isOpen: false
                        });
                    }
                },
                children
            ) : null;
        }
    }]);

    return ClosableAlert;
}(_uiLibrary.Component);

ClosableAlert.propTypes = {
    children: _uiLibrary.PropTypes.node.isRequired,
    onClose: _uiLibrary.PropTypes.func.isRequired
};

exports.default = ClosableAlert;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/profile/announcement-settings.js